'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('declaris-lr', {
            parent: 'fullwidth',
            url: '/declaris/lr/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/declaris/lr/declaris.lr.html',
                    controller: 'DeclarisLRController'
                }
            }
        });
    });
